import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Layout, Card, Typography, Button, Result } from 'antd';
import dayjs from 'dayjs';

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const DangKyThanhCong: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { state } = location;

    if (!state) {
        return (
            <Result
                status="warning"
                title="Không có thông tin đăng ký."
                extra={
                    <Button type="primary" onClick={() => navigate('/dang-ky-kham-tu-xa')}>
                        Quay lại trang đăng ký
                    </Button>
                }
            />
        );
    }

    const { tenBn, namSinh, diaChi, ngayDangKyKham } = state;
    const age = dayjs().year() - namSinh;
    const formattedDate = dayjs(ngayDangKyKham).format('HH:mm [ngày] DD/MM/YYYY');

    return (
        <Layout style={{ minHeight: '100vh', background: '#f0f2f5' }}>
            <Content style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '20px' }}>
                <Card style={{ width: '100%', maxWidth: '800px', textAlign: 'center' }}>
                    <Result
                        status="success"
                        title="Đăng Ký Khám Bệnh Thành Công!"
                        subTitle="Vui lòng kiểm tra lại thông tin dưới đây."
                    />
                    <div style={{ textAlign: 'left', maxWidth: '600px', margin: '0 auto' }}>
                        <Paragraph>
                            Cảm ơn khách hàng <Text strong>{tenBn}</Text>, <Text strong>{age}</Text> tuổi, địa chỉ tại <Text strong>{diaChi}</Text> đã đăng ký khám vào lúc <Text strong>{formattedDate}</Text>.
                        </Paragraph>
                        <Paragraph style={{ marginTop: '20px' }}>
                            Phiếu đăng ký của bạn đã được ghi nhận tại Bệnh viện đa khoa Phủ Diễn.
                        </Paragraph>
                        <Paragraph>
                            Vui lòng đến đúng ngày và cung cấp <Text strong>Họ tên</Text> và <Text strong>Năm sinh</Text> cho nhân viên tại quầy đăng ký để được hướng dẫn.
                        </Paragraph>
                    </div>
                    <Button type="primary" style={{ marginTop: '30px' }} onClick={() => navigate('/dang-ky-kham-tu-xa')}>
                        Thực hiện đăng ký mới
                    </Button>
                </Card>
            </Content>
        </Layout>
    );
};

export default DangKyThanhCong;
